export const kubernetesliveResourceStatusCodes = ["Degraded", "Healthy", "InSync", "OutOfSync", "Progressing", "Unknown", "Missing", "Suspended"] as const;
export type KubernetesLiveResourceStatusCode = (typeof kubernetesliveResourceStatusCodes)[number];
